import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import axiosInstance from '../../../axiosConfig';
import { IApiDataResponse } from '../../../dto/API.dto';
import { IChildStation } from '../../../dto/MessageSharing.dto';
import { AxiosErrorToast } from '../../general/ReusableFunctions';

const fetchChildStations = (childCompanyId: number) => {
  return axiosInstance
    .get(`/v1/company/${childCompanyId}/stations`)
    .then((response: AxiosResponse<IApiDataResponse<IChildStation[]>>) => {
      return response.data.data;
    })
    .catch((error: AxiosError) => {
      AxiosErrorToast(error, 'Error fetching child stations');
      throw error;
    });
};

export const useRqChildStations = (
  childCompanyId: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['api/v1/company', childCompanyId, 'stations'],
    queryFn: () => fetchChildStations(childCompanyId),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
};
